<div>
  <ng-select
    class="ui2-dropdown"
    [class.inline-dropdown]="isInlineDropdown"
    dropdownPosition="bottom"
    [clearAllText]="'newsFeedWidget.clear' | translate"
    [clearable]="false"
    [(ngModel)]="selectedSignalFilterOption"
    (change)="onFilterSelected($event)"
    [placeholder]="'newsFeedWidget.header.placeholderSelector' | translate"
    [items]="signalFilterOptions"
    [loading]="isLoading"
  >
    <ng-template ng-label-tmp let-item="item">
      <div>
        <span>{{ item.label | translate }}</span>
      </div>
    </ng-template>
    <ng-template ng-option-tmp let-item="item">
      <div class="option">
        <span>{{ item.label | translate }}</span>
        <span *ngIf="item.value && item.value !== '0'" class="value-count label-xs-semibold">{{ maybeFormatValue(item.value) }}</span>
      </div>
    </ng-template>
  </ng-select>
</div>
